module.exports = __webpack_public_path__ + "static/LocomotionBP-Burpee-503bc8629d133850ffe96f52ca8e0d23.mp4";